module.exports = __webpack_public_path__ + "img/live-share-QRCode.e3aa03ea.jpg";